// extracted by mini-css-extract-plugin
export default {"RestrictionBanner":"RestrictionIndicator_RestrictionBanner__JcHFl","LockIcon":"RestrictionIndicator_LockIcon__Kvr18"};